import Marquee from "react-fast-marquee";

const ITEMS = ["RAYSTANCE EYEWEAR", "CONFIDENCE YOU CAN WEAR", "YOUR PERSPECTIVE", "YOUR STORY", "YOUR STANCE"];

export const EditorialMarquee = () => (
  <div className="py-20 md:py-28 overflow-hidden border-b border-white/5" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {ITEMS.map((item) => (
        <span key={item} className="flex items-center">
          <span className="font-serif font-light text-5xl md:text-7xl text-gold/90 whitespace-nowrap px-8">
            {item}
          </span>
          <span className="text-gold/40 text-2xl">•</span>
        </span>
      ))}
    </Marquee>
  </div>
);
